var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',_vm._l((_vm.series),function(serie){return _c('figure',{key:serie,class:['serie', ("serie-" + serie)]},_vm._l((10),function(i){return _c('div',{key:i,staticClass:"shade"})}),0)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }